import { render, staticRenderFns } from "./MenuChecklist.vue?vue&type=template&id=5928cfc4&scoped=true&"
import script from "./MenuChecklist.vue?vue&type=script&lang=ts&"
export * from "./MenuChecklist.vue?vue&type=script&lang=ts&"
import style0 from "./MenuChecklist.vue?vue&type=style&index=0&id=5928cfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928cfc4",
  null
  
)

export default component.exports